import React, { useEffect, useState } from "react";
import "./AboutUs.css";
import { useNavigate, useNavigation } from "react-router-dom";
import SelectButton from "../../../components/SelectButton";
import download from "../../../assets/clarity_download-line.png";
import { BsPlusSquare } from "react-icons/bs";
import { createColumnHelper } from "@tanstack/react-table";
import moment from "moment";
import ReusableModal from "./ReusableModal";
import ReactTable from "../../../components/ReactTable";
import plus from "../../../assets/plus-square.png";
import editBond from "../../../assets/editBond.png";
import delBond from "../../../assets/deleteBond.png";
import CustomPagination from "../../../components/CustomPagination";
import axios from "axios";
import ToggleButton from "./Toggle";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import leftIcon from "../../../assets/Left Icons.png";
import DeleteConfirmationModal from "../../../components/DeleteConfirmationModal";

import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Bold,
  Italic,
  Heading,
  Link,
  List,
  BlockQuote,
  Table,
  MediaEmbed,
  PasteFromOffice,
  Font,
  Alignment,
} from "ckeditor5";
export const base_url = process.env.REACT_APP_BASE_URL;
export const api_type = process.env.REACT_APP_API_TYPE;
function AboutUs() {
  const navigate = useNavigate();

  const columnHelper = createColumnHelper();

  const vissionHelper = createColumnHelper();
  const founderHelper = createColumnHelper();
  const [activeTab, setActiveTab] = useState(0);
  const [selectedOccupation, setSelectedOccupation] = useState("");
  const [isBanneActionModelOpen, setisBanneActionModelOpen] = useState(false);
  const [isVisionActionModelOpen, setIsVisionActionModelOpen] = useState(false);
  const [modalMode, setModalMode] = useState();
  const [founderDetails, setFounderDetails] = useState([]);
  const [isJourneyActionModelOpen, setIsJourneyActionModelOpen] =
    useState(false);
  const [isFounderActionModelOpen, setIsFounderActionModelOpen] =
    useState(false);
  const [heading, setheading] = useState("");
  const [text, setText] = useState("");
  const [author, setAuthor] = useState("");
  const [designation, setDesignation] = useState("");
  const [thumbnail, setThumbnail] = useState("");

  const [searchInputApi, setSearchInputApi] = useState("");
  const [investorDetails, setInvestorDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);

  const { userPermissionData } = useSelector((state) => state.userPermission);
  const { cmsData, cmsBondListData } = useSelector((state) => state.cmsData);
  const [data, setData] = useState([]);

  const [error, setError] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenEdit, setIsModalOpenEdit] = useState(false);
  const [newRole, setNewRole] = useState("");
  const [editBlog, setEditBlog] = useState({
    id: "",
    heading: "",
    body: "",
  });

  const [editRole, setEditRole] = useState({
    id: "",
    heading: "",
    body: "",
  });

  const [vissionAndMission, setVissionAndMissionDetails] = useState([]);
  const [vissionHeading, setvissionHeading] = useState("");
  const [vissionBody, setvissionBody] = useState("");
  const [editVission, setEditVission] = useState({
    vissionHeading: "",
    vissionBody: "",
  });

  const [founderName, setFounderName] = useState("");
  const [founderPosition, setFounderPosition] = useState("");
  const [founderImage, setFounderImage] = useState("");
  const [founderLink, setFounderLink] = useState("");
  const [founderStatus, setFounderStatus] = useState("");

  // State for editing Founder Details
  const [editFounder, setEditFounder] = useState({
    founderName: "",
    founderPosition: "",
    founderImage: "",
    founderLink: "",
    founderStatus: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");

  useEffect(() => {
    fetchVissionAndMissionDetails();
  }, [page]);

  useEffect(() => {
    fetchFounder();
  }, [page, activeTab]);

  // Function to update multiple values

  const EditVisionMission = (newValues) => {
    setModalMode("edit");
    setEditVission((prevState) => ({
      ...prevState,
      ...newValues, // Merge new values into the existing state
    }));
    setIsVisionActionModelOpen(true);
    console.log("111", newValues);
    setvissionHeading(newValues.vissionHeading);
    setvissionBody(newValues.vissionBody);
  };

  const journeyHelper = createColumnHelper();
  const [journeyData, setJourneyData] = useState([]);
  const [journeyBody, setjourneyBody] = useState("");
  const [editJourney, setEditJourney] = useState({
    journeyBody: "",
  });

  useEffect(() => {
    fetchJourneyDetails();
  }, [page]);

  const EditJourney = (newValues) => {
    setModalMode("edit");
    setEditJourney((prevState) => ({
      ...prevState,
      ...newValues, // Merge new values into the existing state
    }));
    setIsJourneyActionModelOpen(true);
    setjourneyBody(newValues.journeyBody);
  };

  const fetchJourneyDetails = async () => {
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/ourJourney`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      console.log("role response", response);
      const sortedData = response?.data?.data?.ourJourney?.sort(
        (a, b) => a.id - b.id
      );

      setJourneyData(sortedData);
      // setJourneyPage(response?.data?.data?.currentPage);
      // setJourneyTotal(response?.data?.data?.totalRecords);
      // setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const journeyToggleStatus = async (id) => {
    console.log("did", id);

    // return;
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/ourJourney/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("role response", response);
      toast.success("Status Updated");
      fetchJourneyDetails();
    } catch (err) {
      toast.error(err?.response?.data.message);
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const addNewJourney = async (type) => {
    if (isSubmitting) return;
    
    console.log("type", type);

    let isError = false;

    // Check if journeyBody is empty
    if (!journeyBody) {
      toast.error("Body cannot be empty.");
      isError = true;
    } else if (journeyBody.length > 10000000) {
      toast.error("Body must not exceed 1000000 characters.");
      isError = true;
    }

    // Stop execution if any validation error exists
    if (isError) {
      return;
    }

    const endpoint = `${base_url}/${api_type}/cms/aboutUs/ourJourney`;
    const endpointEdit = `${base_url}/${api_type}/cms/aboutUs/ourJourney/${editJourney.id}`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };

    const payload = {
      body: journeyBody,
    };

    try {
      setIsSubmitting(true);
      const response =
        modalMode === "edit"
          ? await axios.put(endpointEdit, payload, { headers })
          : await axios.post(endpoint, payload, { headers });

      // Reset input fields and states
      toast.success(response?.data?.message);
      fetchJourneyDetails();
      setIsJourneyActionModelOpen(false);
    } catch (err) {
      console.error("Error:", err);
      toast.error(err?.response?.data?.message || "Failed to add Journey");
      setError(err?.message || "An error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  const fetchVissionAndMissionDetails = async () => {
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/cards`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      console.log("role response", response);
      const sortedData = response?.data?.data?.cards?.sort(
        (a, b) => a.id - b.id
      );

      setVissionAndMissionDetails(sortedData);
      console.log("total page", response?.data?.data?.totalPages);
      setPage(response?.data?.data?.currentPage);
      setTotal(response?.data?.data?.totalRecords);
      // setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const vissionToggleStatus = async (id) => {
    console.log("did", id);

    // return;
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/cards/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("role response", response);
      toast.success("Status Updated");
      fetchVissionAndMissionDetails();
    } catch (err) {
      toast.error(err?.response?.data.message);
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const addNewVission = async (type) => {
    if (isSubmitting) return;
    
    console.log("type", type);
    let isError = false;

    // Check if both heading and body are empty
    if (!vissionHeading && !vissionBody) {
      toast.error("Fill the fields before adding.");
      isError = true;
    } else {
      // Check Heading Validation
      if (!vissionHeading || vissionHeading.length > 100000) {
        toast.error(
          !vissionHeading
            ? "Heading cannot be empty."
            : "Heading must not exceed 100 characters."
        );
        isError = true;
      }

      // Check Body Validation
      if (!vissionBody || vissionBody.length > 100000) {
        toast.error(
          !vissionBody
            ? "Body cannot be empty."
            : "Body must not exceed 100 characters."
        );
        isError = true;
      }
    }

    // Stop execution if any validation error exists
    if (isError) {
      return;
    }

    const endpoint = `${base_url}/${api_type}/cms/aboutUs/cards`;
    const endpointEdit = `${base_url}/${api_type}/cms/aboutUs/cards/${editVission.id}`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    };

    const payload = {
      title: vissionHeading,
      body: vissionBody,
    };

    try {
      setIsSubmitting(true);
      const response =
        modalMode === "edit"
          ? await axios.put(endpointEdit, payload, { headers })
          : await axios.post(endpoint, payload, { headers });

      // Reset input fields and states
      toast.success(response?.data?.message);
      fetchVissionAndMissionDetails();
      setIsVisionActionModelOpen(false);
    } catch (err) {
      console.error("Error:", err);
      toast.error(err?.response?.data?.message || "Failed to add vision");
      setError(err?.message || "An error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Function to update multiple values
  const EditBanner = (newValues) => {
    console.log("newValues------------", newValues);

    setModalMode("edit");
    setEditBlog((prevState) => ({
      ...prevState,
      ...newValues, // Merge new values into the existing state
    }));
    setheading(newValues.heading);
    setText(newValues.body);
    setThumbnail(newValues.image);
    setisBanneActionModelOpen(true);
  };

  const EditFounder = (newValues) => {
    setModalMode("edit");
    setEditFounder((prevState) => ({
      ...prevState,
      ...newValues, // Merge new values into the existing state
    }));
    setIsFounderActionModelOpen(true);
    setFounderName(newValues.founderName); // Set founder's name
    setFounderPosition(newValues.founderPosition); // Set founder's position
    setFounderImage(newValues.founderImage); // Set founder's image
    setFounderLink(newValues.founderLink); // Set founder's link
    setFounderStatus(newValues.founderStatus); // Set founder's status
  };

  const fetchInvestorDetails = async () => {
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/header`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      console.log("role response", response?.data?.data);
      const sortedData = response?.data?.data?.headerList?.sort(
        (a, b) => a.id - b.id
      );

      setInvestorDetails(sortedData);
      console.log("total page", response?.data?.data?.totalPages);
      console.log("total page", response?.data?.data?.totalPages);
      setPage(response?.data?.data?.currentPage);
      setTotal(response?.data?.data?.totalRecords);
      // setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  useEffect(() => {
    fetchInvestorDetails();
  }, [page, activeTab === 0]);

  const fetchFounder = async () => {
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/founders`;

    try {
      const response = await axios.get(endpoint, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
        },
      });
      console.log("role response", response?.data?.data?.founders);
      const sortedData = response?.data?.data?.founders?.sort(
        (a, b) => a.id - b.id
      );

      setFounderDetails(sortedData);
      console.log("total page", response?.data?.data?.totalPages);
      console.log("total page", response?.data?.data?.totalPages);
      setPage(response?.data?.data?.currentPage);
      setTotal(response?.data?.data?.totalRecords);
      // setPazeSize(response?.data?.data?.totalPages); // Adjust according to your API response structure
    } catch (err) {
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };

  const toggleFounderStatus = async (id) => {
    console.log("did", id);

    // return;
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/founders/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("role response", response);
      toast.success(response?.data?.message);
      fetchFounder();
    } catch (err) {
      toast.error(err?.response?.data.message);
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  console.log("editBlog", editBlog);

  const toggleStatus = async (id) => {
    console.log("did", id);

    // return;
    const endpoint = `${base_url}/${api_type}/cms/aboutUs/header/${id}/toggle`;

    try {
      const response = await axios.put(
        endpoint,
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Replace 'your-auth-token' with the actual token
          },
        }
      );
      console.log("role response", response);
      toast.success(response?.data?.message);
      fetchInvestorDetails();
    } catch (err) {
      toast.error(err?.response?.data.message);
      console.error("Failed to fetch pending orders:", err);
      setError(err.message);
    }
  };
  console.log("editBlog", editBlog);

  const addNewRole = async (type) => {
    if (isSubmitting) return;
    
    let isError = false;

    // Check if heading and body text are empty
    if (!heading && !text) {
      if (!toast.isActive("heading-body-error")) {
        toast.error("Heading and body text are required.", { toastId: "heading-body-error" });
      }
      isError = true;
    } else {
      // Check Heading Validation
      if (!heading || heading.length > 20000) {
        if (!toast.isActive("heading-error")) {
          toast.error(
            !heading
              ? "Heading cannot be empty."
              : "Heading must not exceed 20000 characters.",
            { toastId: "heading-error" }
          );
        }
        isError = true;
      }

      // Check Body Text Validation
      if (!text || text.length > 30000) {
        if (!toast.isActive("body-error")) {
          toast.error(
            !text
              ? "Body text cannot be empty."
              : "Body text must not exceed 30000 characters.",
            { toastId: "body-error" }
          );
        }
        isError = true;
      }

      // Check Thumbnail Validation - Required for both new and edit
      if (!thumbnail) {
        if (!toast.isActive("thumbnail-error")) {
          toast.error("Thumbnail image is required.", { toastId: "thumbnail-error" });
        }
        isError = true;
      }
    }

    // Stop execution if any validation error exists
    if (isError) {
      return;
    }

    const endpoint = `${base_url}/${api_type}/cms/aboutUs/header`;
    const endpointEdit = `${base_url}/${api_type}/cms/aboutUs/header/${editBlog?.id}`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };

    try {
      setIsSubmitting(true);
      let response;

      if (modalMode === "edit") {
        // For edit/PUT request, use FormData with file
        const formData = new FormData();
        formData.append("text", heading);
        formData.append("body", text);
        if (thumbnail) {
          formData.append("file", thumbnail);
        }

        response = await axios.put(endpointEdit, formData, {
          headers: {
            ...headers,
            "Content-Type": "multipart/form-data",
          },
        });
      } else {
       // For new/POST request, use FormData to include the file
       const formData = new FormData();
       formData.append("text", heading);
       formData.append("body", text);
       if (thumbnail) {
         formData.append("file", thumbnail);
       }

       response = await axios.post(endpoint, formData, {
         headers: {
           ...headers,
           "Content-Type": "multipart/form-data",
         },
       });
      }

      toast.success(response?.data?.message);
      fetchInvestorDetails();
      setisBanneActionModelOpen(false);

      // Reset form fields
      setheading("");
      setText("");
      setThumbnail("");
      setSelectedFileName("");
    } catch (err) {
      console.error("Error:", err);
      toast.error(err?.response?.data?.message || "Failed to add banner");
      setError(err?.message || "An error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  const addFounder = async (type) => {
    if (isSubmitting) return;
    
    let isError = false;

    // Validation checks
    if (!founderName && !founderPosition && !founderLink) {
      toast.error("Fill all required fields before adding.");
      isError = true;
    } else {
      // Check Name Validation
      if (!founderName || founderName.length > 10000) {
        toast.error(
          !founderName
            ? "Name cannot be empty."
            : "Name must not exceed 100 characters."
        );
        isError = true;
      }

      // Check Position Validation
      if (!founderPosition || founderPosition.length > 100000) {
        toast.error(
          !founderPosition
            ? "Position cannot be empty."
            : "Position must not exceed 100 characters."
        );
        isError = true;
      }

      // Check Link Validation
      if (!founderLink || founderLink.length > 20000) {
        toast.error(
          !founderLink
            ? "Link cannot be empty."
            : "Link must not exceed 200 characters."
        );
        isError = true;
      }
    }

    if (isError) return;

    const endpoint = `${base_url}/${api_type}/cms/aboutUs/founders`;
    const endpointEdit = `${base_url}/${api_type}/cms/aboutUs/founders/${editFounder?.id}`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    };

    try {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append("name", founderName);
      formData.append("designation", founderPosition);
      formData.append("link", founderLink);

      // Handle image file differently for edit vs new
      if (modalMode === "edit") {
        // If a new file is selected, use that
        if (thumbnail instanceof File) {
          formData.append("file", thumbnail);
        } else if (founderImage) {
          // If no new file but we have existing image URL, pass it as string
          formData.append("image", founderImage);
        }
      } else {
        // For new entries, require file upload
        if (!thumbnail) {
          toast.error("Please upload an image file");
          setIsSubmitting(false);
          return;
        }
        formData.append("file", thumbnail);
      }

      const response = modalMode === "edit"
        ? await axios.put(endpointEdit, formData, {
            headers: {
              ...headers,
              "Content-Type": "multipart/form-data",
            },
          })
        : await axios.post(endpoint, formData, {
            headers: {
              ...headers,
              "Content-Type": "multipart/form-data",
            },
          });

      toast.success(response?.data?.message);
      fetchFounder();
      setIsFounderActionModelOpen(false);
      setIsSubmitting(false);

      // Reset form fields
      setFounderName("");
      setFounderPosition("");
      setFounderLink("");
      setThumbnail("");
      setFounderImage("");
    } catch (err) {
      setIsSubmitting(false);
      console.error("Error:", err);
      toast.error(err?.response?.data?.message || "Failed to add founder");
      setError(err?.message || "An error occurred");
    }
  };

  const tabData = [
    { label: "Banner" },
    { label: "Vision & mission" },
    { label: "Our Journey" },
    { label: "Founder & Cofounder" },
  ];

  const addData = () => {
    const tabDataMapping = {
      0: cmsData?.homeCards || [],
      // 1: cmsData?.bondIds || [],
      2: cmsData?.faqs || [],
      3: cmsData?.testimonials || [],
    };

    setData(tabDataMapping[activeTab] || []);
    if (activeTab === 1 && cmsData?.bondIds) {
      const bondIdStatusMapping = cmsData?.bondIds?.reduce((acc, bond) => {
        acc[bond.id] = bond.status;
        return acc;
      }, {});

      const getFilterBondData = cmsBondListData
        ?.filter((item) => bondIdStatusMapping?.hasOwnProperty(item.id))
        .map((item) => ({
          ...item,
          status: bondIdStatusMapping[item.id],
        }));

      console.log("getFilterBondData", getFilterBondData);
      setData(getFilterBondData);
    }
  };

  useEffect(() => {
    setData([]);
    addData();
  }, [activeTab, cmsData]);

  const columns = [
    columnHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm 
               
            `}
          >
            {info.row.index + 1}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    columnHelper.accessor("text", {
      cell: (info) => info.renderValue(),
      header: () => <span>Heading</span>,
    }),

    columnHelper.accessor("body", {
      cell: (info) => (
        <>
          <style>
            {`
      ul, ol {
        margin: 0;
        padding-left: 20px;
        list-style: disc; /* Ensure bullet points */
      }
      ol {
        list-style: decimal; /* Ensure ordered list numbers */
      }
      li {
        margin-bottom: 5px;
        }
        `}
          </style>
          <div dangerouslySetInnerHTML={{ __html: info.renderValue() }} />
        </>
      ),
      header: () => <span>Body</span>,
    }),

    columnHelper.accessor("image", {
      cell: (info) => info.renderValue(),
      header: () => <span>Image</span>,
    }),

    columnHelper.accessor("status", {
      cell: (info) => {
        const status = info?.row;
        const roleId = info?.row?.original?.id;
        const roleType = info?.row?.original?.name;
        console.log("status", status);
        console.log("info", info);
        return (
          <div
            className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm cursor-pointer`}
          >
            {/* {kycStatus === "approve" ? "Approved" : "Pending"} */}
            <ToggleButton
              value={status}
              handleToggleStatus={toggleStatus}
              roleId={roleId}
              roleType={roleType}
            />
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),

    columnHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;
        console.log("info?.row?.original", info?.row?.original);

        return (
          <div className="flex gap-2">
            {userPermissionData?.user?.edit && (
              <div
                className="flex flex-start "
                onClick={() => {
                  EditBanner({
                    id: uniqueId,
                    heading: info.row.original.text,
                    body: info.row.original.body,
                    image: info?.row?.original?.image,
                  });
                }}
              >
                <img src={editBond} alt="Eye " className="cursor-pointer" />
              </div>
            )}
            <img
              src={delBond}
              alt="Delete"
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this item?")) {
                  const endpoint = `${base_url}/${api_type}/cms/aboutUs/${activeTab === 0 ? 'header' : 
                                  activeTab === 1 ? 'cards' : 
                                  activeTab === 2 ? 'ourJourney' : 
                                  'founders'}/${uniqueId}`;
                  
                  axios.delete(endpoint, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  })
                  .then((response) => {
                    toast.success(response?.data?.message || "Deleted successfully");
                    // Refresh data based on current tab
                    if (activeTab === 0) fetchInvestorDetails();
                    else if (activeTab === 1) fetchVissionAndMissionDetails();
                    else if (activeTab === 2) fetchJourneyDetails();
                    else if (activeTab === 3) fetchFounder();
                  })
                  .catch((err) => {
                    toast.error(err?.response?.data?.message || "Failed to delete");
                  });
                }
              }}
            />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];

  const visionColumns = [
    vissionHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm 
               
            `}
          >
            {info.row.index + 1}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    vissionHelper.accessor("title", {
      cell: (info) => info.renderValue(),
      header: () => <span>Heading</span>,
    }),

    vissionHelper.accessor("body", {
      cell: (info) => (
        <>
          <style>
            {`
            ul, ol {
              margin: 0;
              padding-left: 20px;
              list-style: disc; /* Ensure bullet points */
            }
            ol {
              list-style: decimal; /* Ensure ordered list numbers */
            }
            li {
              margin-bottom: 5px;
            }
          `}
          </style>
          <div dangerouslySetInnerHTML={{ __html: info.renderValue() }} />
        </>
      ),
      header: () => <span>Body</span>,
    }),

    vissionHelper.accessor("status", {
      cell: (info) => {
        const status = info?.row;
        const roleId = info?.row?.original?.id;
        const roleType = info?.row?.original?.name;
        console.log("status", status);
        console.log("info", info);
        return (
          <div
            className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm cursor-pointer`}
          >
            <ToggleButton
              value={status}
              handleToggleStatus={vissionToggleStatus}
              roleId={roleId}
              roleType={roleType}
            />
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),

    vissionHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;

        console.log("1111", info.row.original);

        return (
          <div className="flex gap-2">
            {userPermissionData?.user?.edit && (
              <div
                className="flex flex-start "
                onClick={() => {
                  EditVisionMission({
                    id: uniqueId,
                    vissionHeading: info.row.original.title,
                    vissionBody: info.row.original.body,
                  });
                }}
              >
                <img src={editBond} alt="Eye " className="cursor-pointer" />
              </div>
            )}
            <img
              src={delBond}
              alt="Delete"
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this item?")) {
                  const endpoint = `${base_url}/${api_type}/cms/aboutUs/cards/${uniqueId}`;
                  
                  axios.delete(endpoint, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  })
                  .then((response) => {
                    toast.success(response?.data?.message || "Deleted successfully");
                    fetchVissionAndMissionDetails();
                  })
                  .catch((err) => {
                    toast.error(err?.response?.data?.message || "Failed to delete");
                  });
                }
              }}
            />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];
  const journeyColumns = [
    journeyHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm 
               
            `}
          >
            {info.row.index + 1}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),

    journeyHelper.accessor("body", {
      cell: (info) => (
        <>
          <style>
            {`
            ul, ol {
              margin: 0;
              padding-left: 20px;
              list-style: disc; /* Ensure bullet points */
            }
            ol {
              list-style: decimal; /* Ensure ordered list numbers */
            }
            li {
              margin-bottom: 5px;
            }
          `}
          </style>
          <div dangerouslySetInnerHTML={{ __html: info.renderValue() }} />
        </>
      ),
      header: () => <span>Body</span>,
    }),

    journeyHelper.accessor("status", {
      cell: (info) => {
        const status = info?.row;
        const roleId = info?.row?.original?.id;
        const roleType = info?.row?.original?.name;
        console.log("status", status);
        console.log("info", info);
        return (
          <div
            className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm cursor-pointer`}
          >
            {/* {kycStatus === "approve" ? "Approved" : "Pending"} */}
            <ToggleButton
              value={status}
              handleToggleStatus={journeyToggleStatus}
              roleId={roleId}
              roleType={roleType}
            />
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),

    journeyHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;

        console.log("11", info?.row?.original);

        return (
          <div className="flex gap-2">
            {userPermissionData?.user?.edit && (
              <div
                className="flex flex-start "
                onClick={() => {
                  EditJourney({
                    id: uniqueId,
                    journeyBody: info?.row?.original?.body,
                  });
                }}
              >
                <img src={editBond} alt="Eye " className="cursor-pointer" />
              </div>
            )}
            <img
              src={delBond}
              alt="Delete"
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this item?")) {
                  const endpoint = `${base_url}/${api_type}/cms/aboutUs/ourJourney/${uniqueId}`;
                  
                  axios.delete(endpoint, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  })
                  .then((response) => {
                    toast.success(response?.data?.message || "Deleted successfully");
                    fetchJourneyDetails();
                  })
                  .catch((err) => {
                    toast.error(err?.response?.data?.message || "Failed to delete");
                  });
                }
              }}
            />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];

  const founderColumns = [
    founderHelper.display({
      id: "sn", // A unique ID for the column
      cell: (info) => {
        const status = info?.row?.original?.status;
        return (
          <div
            className={` w-[27px] h-[27 px] py-1 flex justify-center items-center rounded text-center text-sm 
               
            `}
          >
            {info.row.index + 1}
          </div>
        );
      },
      header: () => <span>Sr. No.</span>,
    }),
    founderHelper.accessor("name", {
      cell: (info) => info.renderValue(),
      header: () => <span>Name</span>,
    }),
    founderHelper.accessor("designation", {
      cell: (info) => info.renderValue(),
      header: () => <span>Position</span>,
    }),
    founderHelper.accessor("image", {
      cell: (info) => info.renderValue(),
      header: () => <span>Image</span>,
    }),
    founderHelper.accessor("link", {
      cell: (info) => info.renderValue(),
      header: () => <span>Link</span>,
    }),

    founderHelper.accessor("status", {
      cell: (info) => {
        const status = info?.row;
        const roleId = info?.row?.original?.id;
        const roleType = info?.row?.original?.name;
        console.log("status", status);
        console.log("info", info);
        return (
          <div
            className={` w-[50px] h-[27px] py-1 flex justify-center items-center rounded text-center text-sm cursor-pointer`}
          >
            {/* {kycStatus === "approve" ? "Approved" : "Pending"} */}
            <ToggleButton
              value={status}
              handleToggleStatus={toggleFounderStatus}
              roleId={roleId}
              roleType={roleType}
            />
          </div>
        );
      },
      header: () => <span>Status</span>,
    }),

    founderHelper.accessor((row) => row, {
      id: "action",
      cell: (info) => {
        const uniqueId = info?.row?.original?.id;
        const name = info?.row?.original?.name;

        console.log("investorid", info?.row?.original);

        return (
          <div className="flex gap-2">
            {userPermissionData?.user?.edit && (
              <div
                className="flex flex-start "
                onClick={() => {
                  EditFounder({
                    id: uniqueId,
                    founderName: info?.row?.original?.name,
                    founderPosition: info?.row?.original?.designation,
                    founderImage: info?.row?.original?.image,
                    founderLink: info?.row?.original?.link,
                    founderStatus: info?.row?.original?.status,
                  });
                }}
              >
                <img src={editBond} alt="Eye " className="cursor-pointer" />
              </div>
            )}
            <img
              src={delBond}
              alt="Delete"
              className="cursor-pointer"
              onClick={() => {
                if (window.confirm("Are you sure you want to delete this item?")) {
                  const endpoint = `${base_url}/${api_type}/cms/aboutUs/founders/${uniqueId}`;
                  
                  axios.delete(endpoint, {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                  })
                  .then((response) => {
                    toast.success(response?.data?.message || "Deleted successfully");
                    fetchFounder();
                  })
                  .catch((err) => {
                    toast.error(err?.response?.data?.message || "Failed to delete");
                  });
                }
              }}
            />
          </div>
        );
      },
      header: () => <span>Action</span>,
    }),
  ];

  const closeBannerModal = () => {
    setisBanneActionModelOpen(false);
    setThumbnail("");
    setSelectedFileName("");
  };

  const closeVissionModalEdit = () => {
    setIsVisionActionModelOpen(false);
    setThumbnail("");
    setSelectedFileName("");
  };

  const closeJourneyModalEdit = () => {
    setIsJourneyActionModelOpen(false);
    setThumbnail("");
    setSelectedFileName("");
    setjourneyBody("");
  };

  const closeFounderModalEdit = () => {
    setIsFounderActionModelOpen(false);
    setThumbnail("");
    setSelectedFileName("");
    setFounderName("");
    setFounderPosition("");
    setFounderLink("");
    setFounderImage("");
  };

  const getTabDetails = () => {
    switch (tabData[activeTab]?.label) {
      case "Banner":
        return { data: investorDetails, cols: columns };
      case "Vision & mission":
        return { data: investorDetails, cols: visionColumns };
      case "Our Journey":
        return { data: investorDetails, cols: journeyColumns };
      case "Founder & Cofounder":
        return { data: investorDetails, cols: founderColumns };
      default:
        return { data: [], cols: [] };
    }
  };

  // Function to handle modal opening based on activeTab
  const handleAdd = () => {
    setText("");
    setheading("");
    setvissionBody("");
    setvissionHeading("");
    setFounderName("");
    setFounderPosition("");
    setFounderImage("");
    setFounderLink("");
    setThumbnail("");
    setFounderStatus("");
    setjourneyBody("");
    setModalMode("add");

    const currentLabel = tabData[activeTab]?.label;

    if (currentLabel === "Banner") {
      setisBanneActionModelOpen(true);
    } else if (currentLabel === "Vision & mission") {
      setIsVisionActionModelOpen(true);
    } else if (currentLabel === "Our Journey") {
      setIsJourneyActionModelOpen(true);
    } else if (currentLabel === "Founder & Cofounder") {
      setIsFounderActionModelOpen(true);
    } else {
      // Handle other cases if needed
      console.log("No modal associated with this tab");
    }
  };

  const { tabledata, cols } = getTabDetails();

  console.log("mode----", modalMode);

  return (
    <div className=" mt-[60px] px-4">
      <div className="w-fit mt-11 flex items-center justify-between border border-gray-300  mb-6">
        {/* Render Tabs Dynamically */}
        {tabData.map((tab, index) => (
          <div
            key={index}
            onClick={() => setActiveTab(index)}
            className={`px-6 py-2 font-semibold cursor-pointer font-montserrat ${
              activeTab === index
                ? "text-white bg-[#035C98] "
                : "text-gray-800 bg-[#FFFFFF] border-r border-[#E8E8E8]"
            }`}
          >
            {tab.label}
          </div>
        ))}

        {/* Dashed Divider */}
      </div>
      <div className="bg-white px-8  mt-4 rounded-[10px] border">
        <div>
          <div className="flex flex-wrap items-center justify-between py-4 gap-x-2 gap-y-4">
            {/* Title Section */}
            <h5 className="text-[#252C32] text-[18px] font-bold">
              {tabData[activeTab]?.label || "Banner"}
            </h5>

            {/* Add New Button */}
            <div
              className="bg-[#2D659F] px-4 py-2 text-white rounded-xl flex items-center gap-2 cursor-pointer ml-auto"
              onClick={() => handleAdd()}
            >
              <BsPlusSquare size={18} className="mt-px" />
              Add new
            </div>
          </div>
        </div>

        {/* Modal Component */}

        {isBanneActionModelOpen && (
          <ReusableModal
            content={
              <div className="w-full max-w-md mx-auto my-auto bg-white ">
                <h2 className="text-center text-[24px] font-semibold mb-4">
                  {modalMode === "add" ? "Add Banner" : " Edit Banner"}
                </h2>

                <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                  Heading
                </label>
                <div className="flex mt-2 mb-4">
                  <input
                    type="text"
                    value={heading}
                    placeholder="type here"
                    className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                    onChange={(e) => setheading(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Body Text
                  </label>
                  <div
                    className="py-2"
                    style={{
                      // border: "1px solid #ccc",

                      marginTop: "10px",
                      lineHeight: "1.6",
                    }}
                  >
                    <style>
                      {`
                                                ul, ol {
                                                  margin: 0;
                                                  padding-left: 20px;
                                                  list-style: disc; /* Ensure bullet points */
                                                }
                                                ol {
                                                  list-style: decimal; /* Ensure ordered list numbers */
                                                }
                                                li {
                                                  margin-bottom: 5px;
                                                }
                                              `}
                    </style>
                    <CKEditor
                      editor={ClassicEditor}
                      data={text} // Prefill CKEditor with body text
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setText(data);
                      }}
                      // onChange={(event, editor) => {
                      //   const data = editor.getData();
                      //   console.log({ event, editor, data }); // Logs the editor data in the console
                      //   // onChange={handleInputChange}
                      //   setText(data);
                      // }}
                      config={{
                        licenseKey: "GPL", // Use the GPL license.
                        plugins: [
                          Essentials,
                          Paragraph,
                          Bold,
                          Italic,
                          Heading,
                          Link,
                          List,
                          BlockQuote,
                          Image,
                          // Table,
                          MediaEmbed,
                          PasteFromOffice,
                          Font,
                          Alignment,
                        ],
                        toolbar: [
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "|",
                          "bulletedList",
                          "numberedList",
                          "|",
                          "blockQuote",
                          "insertTable",
                          "|",
                          "undo",
                          "redo",
                          "|",
                          "alignment:left",
                          "alignment:center",
                          "alignment:right",
                          "alignment:justify",
                          "|",
                          "fontColor",
                          "fontBackgroundColor",
                          "fontSize",
                          "|",
                          // "mediaEmbed",
                        ],
                      }}
                    />
                  </div>

                  <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text-[#000000]">
                    Upload Thumbnail
                  </label>
                  <div className="flex items-center mt-2 mb-4 relative">
                    <input
                      type="file"
                      id="thumbnailUpload"
                      accept="image/*"
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      onChange={(e) => {
                        if (e.target.files[0]) {
                          const file = e.target.files[0];
                          // Additional validation to ensure it's an image
                          if (!file.type.startsWith('image/')) {
                            toast.error('Please upload only image files');
                            e.target.value = ''; // Clear the input
                            return;
                          }
                          setThumbnail(file);
                          setSelectedFileName(file.name);
                        }
                      }}
                    />
                    <div className="flex items-center justify-between w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]">
                      <span className="text-gray-500 truncate flex-1">
                        {selectedFileName || (modalMode === "edit" && thumbnail) || "Add file"}
                      </span>
                      <img
                        src={leftIcon}
                        className="h-[30px] w-[30px] cursor-pointer ml-2"
                        alt="upload"
                      />
                    </div>
                  </div>
                </div>
              </div>
            }
            onUpload={() => addNewRole("new")}
            ButtonValue={modalMode === "add" ? "Add" : "Update"}
            onClose={closeBannerModal}
            isSubmitting={isSubmitting}
          />
        )}

        {isVisionActionModelOpen && (
          <ReusableModal
            content={
              <div className="w-full max-w-md mx-auto my-auto bg-white ">
                <h2 className="text-center text-[24px] font-semibold mb-4">
                  {modalMode === "add"
                    ? "Add Vision & mission"
                    : "Edit Vision & mission"}
                </h2>

                <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                  Heading
                </label>
                <div className="flex mt-2 mb-4">
                  <input
                    type="text"
                    value={vissionHeading}
                    placeholder="type here"
                    className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px] "
                    onChange={(e) => setvissionHeading(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Body Text
                  </label>
                  <div
                    style={{
                      // border: "1px solid #ccc",

                      marginTop: "10px",
                      lineHeight: "1.6",
                    }}
                  >
                    <style>
                      {`
                                            ul, ol {
                                              margin: 0;
                                              padding-left: 20px;
                                              list-style: disc; /* Ensure bullet points */
                                            }
                                            ol {
                                              list-style: decimal; /* Ensure ordered list numbers */
                                            }
                                            li {
                                              margin-bottom: 5px;
                                            }
                                          `}
                    </style>
                    <CKEditor
                      editor={ClassicEditor}
                      data={vissionBody} // Prefill CKEditor with body text
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setvissionBody(data);
                      }}
                      config={{
                        licenseKey: "GPL", // Use the GPL license.
                        plugins: [
                          Essentials,
                          Paragraph,
                          Bold,
                          Italic,
                          Heading,
                          Link,
                          List,
                          BlockQuote,
                          Image,
                          // Table,
                          MediaEmbed,
                          PasteFromOffice,
                          Font,
                          Alignment,
                        ],
                        toolbar: [
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "|",
                          "bulletedList",
                          "numberedList",
                          "|",
                          "blockQuote",
                          "insertTable",
                          "|",
                          "undo",
                          "redo",
                          "|",
                          "alignment:left",
                          "alignment:center",
                          "alignment:right",
                          "alignment:justify",
                          "|",
                          "fontColor",
                          "fontBackgroundColor",
                          "fontSize",
                          "|",
                          // "mediaEmbed",
                        ],
                      }}
                    />
                  </div>
                </div>
              </div>
            }
            onUpload={() => addNewVission("new")}
            ButtonValue={modalMode === "add" ? "Add" : "Update"}
            onClose={closeVissionModalEdit}
            isSubmitting={isSubmitting}
          />
        )}
        {isJourneyActionModelOpen && (
          <ReusableModal
            content={
              <div className="w-full max-w-md mx-auto my-auto bg-white ">
                <h2 className="text-center text-[24px] font-semibold mb-4">
                  {modalMode === "add" ? "Add Our Journey" : "Edit Our Journey"}
                </h2>

                <div>
                  <label className="block text-sm font-medium mb-1">
                    Body Text
                  </label>
                  <div
                    style={{
                      // border: "1px solid #ccc",

                      marginTop: "10px",
                      lineHeight: "1.6",
                    }}
                  >
                    <style>
                      {`
                                             ul, ol {
                                               margin: 0;
                                               padding-left: 20px;
                                               list-style: disc; /* Ensure bullet points */
                                             }
                                             ol {
                                               list-style: decimal; /* Ensure ordered list numbers */
                                             }
                                             li {
                                               margin-bottom: 5px;
                                             }
                                           `}
                    </style>
                    <CKEditor
                      editor={ClassicEditor}
                      data={journeyBody} // Prefill CKEditor with body text
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        // const plainText = stripHtml(data)
                        setjourneyBody(data);
                      }}
                      config={{
                        licenseKey: "GPL", // Use the GPL license.
                        plugins: [
                          Essentials,
                          Paragraph,
                          Bold,
                          Italic,
                          Heading,
                          Link,
                          List,
                          BlockQuote,
                          Image,
                          // Table,
                          MediaEmbed,
                          PasteFromOffice,
                          Font,
                          Alignment,
                        ],
                        toolbar: [
                          "heading",
                          "|",
                          "bold",
                          "italic",
                          "link",
                          "|",
                          "bulletedList",
                          "numberedList",
                          "|",
                          "blockQuote",
                          "insertTable",
                          "|",
                          "undo",
                          "redo",
                          "|",
                          "alignment:left",
                          "alignment:center",
                          "alignment:right",
                          "alignment:justify",
                          "|",
                          "fontColor",
                          "fontBackgroundColor",
                          "fontSize",
                          "|",
                          // "mediaEmbed",
                        ],
                        // contentsCss: [
                        //   `.ck-editor__editable {
                        //     max-height: 400px;
                        //     height: 400px;
                        //     overflow-y: auto;
                        //     scrollbar-width: thin;
                        //     scrollbar-color: #888 #f1f1f1;
                        //   }
                        //   .ck-editor__editable::-webkit-scrollbar {
                        //     width: 8px;
                        //   }
                        //   .ck-editor__editable::-webkit-scrollbar-thumb {
                        //     background-color: #888;
                        //     border-radius: 4px;
                        //   }
                        //   .ck-editor__editable::-webkit-scrollbar-track {
                        //     background-color: #f1f1f1;
                        //   }`,
                        // ],
                      }}
                    />
                  </div>
                </div>
              </div>
            }
            onUpload={() => addNewJourney("new")}
            ButtonValue={modalMode === "add" ? "Add" : "Update"}
            onClose={closeJourneyModalEdit}
            isSubmitting={isSubmitting}
          />
        )}

        {isFounderActionModelOpen && (
          <ReusableModal
            content={
              <div className="w-full max-w-md mx-auto my-auto bg-white">
                <h2 className="text-center text-[24px] font-semibold mb-4">
                  {modalMode === "add" ? "Add Details" : "Edit Details"}
                </h2>

                {/* Name Input Field */}
                <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                  Name
                </label>
                <div className="flex mt-2 mb-4">
                  <input
                    type="text"
                    value={founderName} // Bind to state
                    placeholder="type here"
                    className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                    onChange={(e) => setFounderName(e.target.value)} // Set state for name
                  />
                </div>

                {/* Position Input Field */}
                <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                  Position
                </label>
                <div className="flex mt-2 mb-4">
                  <input
                    type="text"
                    value={founderPosition} // Bind to state
                    placeholder="type here"
                    className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                    onChange={(e) => setFounderPosition(e.target.value)} // Set state for position
                  />
                </div>

                {/* Link Input Field */}
                <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text[#000000] ">
                  Link
                </label>
                <div className="flex mt-2 mb-4">
                  <input
                    type="text"
                    value={founderLink} // Bind to state
                    placeholder="type here"
                    className="w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]"
                    onChange={(e) => setFounderLink(e.target.value)} // Set state for link
                  />
                </div>

                {/* Image Upload */}
                <label className="font-raleway text-[16px] font-medium leading-[18.78px] text-left text-[#000000]">
                  Upload Image
                </label>
                <div className="flex items-center mt-2 mb-4 relative">
                  <input
                    type="file"
                    id="thumbnailUpload"
                    accept="image/*"
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    onChange={(e) => {
                      if (e.target.files[0]) {
                        const file = e.target.files[0];
                        if (!file.type.startsWith('image/')) {
                          toast.error('Please upload only image files');
                          e.target.value = '';
                          setSelectedFileName("");
                          return;
                        }
                        setThumbnail(file);
                        setSelectedFileName(file.name);
                      }
                    }}
                  />
                  <div className="flex items-center justify-between w-full h-14 p-2.5 border border-[#E6E6E6] rounded-[13px]">
                    <span className="text-gray-500 truncate flex-1">
                      {selectedFileName || (modalMode === "edit" && founderImage) || "Add file"}
                    </span>
                    <img
                      src={leftIcon}
                      className="h-[30px] w-[30px] cursor-pointer ml-2"
                      alt="upload"
                    />
                  </div>
                </div>
              </div>
            }
            onUpload={() => addFounder("new")} // Handle upload based on modal mode
            ButtonValue={modalMode === "add" ? "Add" : "Update"} // Set button text based on mode
            onClose={closeFounderModalEdit} // Close modal on button click
            isSubmitting={isSubmitting}
          />
        )}
      </div>

      <div className="w-full font-poppins mt-3 rounded-[10px] border-t pt-4 bg-white">
        {activeTab === 0 && (
          <ReactTable
            key={JSON?.stringify(investorDetails)} // Investor details key for re-rendering
            defaultData={investorDetails} // Pass investor details
            columns={cols} // Use the columns for investors
          />
        )}

        {activeTab === 1 && (
          <ReactTable
            key={JSON?.stringify(vissionAndMission)} // Vision and Mission key for re-rendering
            defaultData={vissionAndMission} // Pass vision and mission data
            columns={cols} // Use the columns for vision and mission
          />
        )}

        {activeTab === 2 && (
          <ReactTable
            key={JSON?.stringify(journeyData)} // Journey details key for re-rendering
            defaultData={journeyData} // Pass journey details
            columns={cols} // Use the columns for journey details
          />
        )}

        {activeTab === 3 && (
          <ReactTable
            key={JSON?.stringify(founderDetails)} // Founder details key for re-rendering
            defaultData={founderDetails} // Pass founder details
            columns={cols} // Use the columns for founder details
          />
        )}
      </div>

      {/* {investorDetails?.length > 0 && (
        <div className="w-auto">
          <CustomPagination
            currentPage={page}
            setCurrentPage={setPage}
            totalItems={total}
            itemsPerPage={10}
            maxPageNumbersToShow={5}
          />
        </div>
      )} */}
    </div>
  );
}

export default AboutUs;
